import styled from 'styled-components';

const FeaturedItemHolder = styled.div`

  .featured-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr /*repeat(3, 1fr)*/;
    grid-auto-rows: auto;
    gap: 10px;

    &:focus-visible {
      outline: var(--focus-visible-outline);
      outline-offset: 2px;
      width: calc(100% - 4px);
      margin-left: 4px;
    }

    &__big-item {
      position: relative;
      grid-column: 1 / 3;
      grid-row: 1 / 3;

      .jwplayer .jw-error-msg {
        align-items: center;
        background-color: transparent;
        padding: 0;
        width: 70%;
        top: 70%;
      }

      .jw-error-msg .jw-icon.jw-reset {
        display: none;
      }

      .jw-error-text {
        /* iphone 5/SE START */
        @media only screen and (max-width: 320px) {
          font-size: 12.1px;
        }
        /* iphone 5/SE END */
        @media only screen and (min-width: 321px) and (max-width: 1024px) {
          font-size: 15.6px;
        }
        height: 1.4em;
        overflow: hidden;
        font-size: 30px;
        background-color: var(--clr-black);
        opacity: 0.5;
        text-align: center;
      }

      &.only-item {
        grid-column: 1 / 4;
      }

      @media only screen and (max-width: 920px) {
        grid-column: 1 / 4;
      }

      &.wide {
        grid-column: 1 / 4;
      }

      /* CPACWEB-277: graceful fallback when the livestream list filters down to zero valid items.
         Replaces the white box that would otherwise show in the center of the home page. */
      &.placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("/static-assets/images/common/slate_background.jpg") center center / cover no-repeat;
        color: var(--clr-black);
        min-height: 240px;
        aspect-ratio: 16 / 9;
        padding: 20px;
      }

      &__placeholder-text {
        font-size: 28px;
        font-weight: 600;
        text-align: center;
        line-height: 1.3;

        @media only screen and (max-width: 920px) {
          font-size: 22px;
        }

        @media only screen and (max-width: 480px) {
          font-size: 18px;
        }
      }

      &__live-label-holder {
        position: absolute;
        top: 4px;
        left: 4px;
        z-index: 1;
      }

      &__cpactv {
        position: absolute;
        top: 1px;
        right: 1px;
        background-color: var(--clr-black);
        color: var(--clr-white);
        font-weight: 700;
        width: 120px;
        height: 30px;
        z-index: 1;

        img {
          display: inline-block;
          height: 100%;
        }

        span {
          position: absolute;
          top: 5px;
        }
      }

    }

    &__small-item {
      position: relative;
      border: var(--featured-small-item-border);
      text-decoration: none;
      &:focus-visible {
        outline: var(--focus-visible-outline);
      }

      @media screen and (max-width: 520px) {
        grid-column: 1 / 4;
      }

      &__info {
        position: relative;
        min-height: 100%;
        background-color: var(--clr-white);

        &__header {
          position: relative;
          padding-top: calc((9 * var(--aspect-ratio-image-width)) / 16);
        }

        p {
          cursor: default;
        }

        a {
          &:focus-visible {
            text-decoration: underline;
            text-decoration-color: var(--headings-text-color);
            text-decoration-thickness: 3px;
          }
          img {
            width: var(--aspect-ratio-image-width);
            height: calc((9 * var(--aspect-ratio-image-width)) / 16);
            object-fit: contain;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        &__description a {
          text-decoration: none;
        }
        &__description a:hover {
          text-decoration: underline !important;
          text-decoration-color: var(--cat-link-color) !important;
        }
        &__description a:focus-visible .featured-container__small-item__info__title,
        &__description a:focus-visible .featured-container__small-item__info__title span {
          text-decoration: underline !important;
          text-decoration-color: var(--cat-link-color) !important;
          text-decoration-thickness: 3px !important;
        }
        &__category {
          display: block;
          text-decoration: none;
          padding: 10px 20px 0px 20px;
          font-weight: 700;
          color: var(--cat-link-color);
          text-transform: uppercase;
          margin: 0;
          font-size: 14px;
        }

        &__title {
          font-family: var(--font-family-default);
          display: block;
          text-decoration: none;
          padding: 0px 20px 20px 20px;
          color: var(--headings-text-color);
          font-weight: 500;
          font-size: 17px;
          line-height: 1.5em;
          margin: 0;
        }
      }

      &__live-info {
        position: absolute;
        bottom: 0px;
        font-family: var(--font-family-default);
        background: var(--clr-black);
        color: var(--clr-white);
        width: 100%;
        height: 30px;
        z-index: 1;
        text-align: center;
        font-weight: 900;
        opacity: 0.8;
        line-height: 28px;
        font-size: 15px;
        &:focus-visible {
          outline: var(--focus-visible-outline);
        }
      }

      &__cpactv {
        position: absolute;
        top: 0;
        right: 0;
        background-color: var(--clr-black);
        color: var(--clr-white);
        font-weight: 700;
        width: 120px;
        height: 30px;

        img {
          display: inline-block;
          width: auto !important;
          max-height: none !important;
          min-height: 0 !important;
          height: 100%;
        }

        span {
          position: absolute;
          top: 2px;
          right: 15px;
        }
      }
      .t-l {
        position: absolute;
        top: 2.5px;
        left: 2.5px;
        z-index: 1;
      }
      .t-r {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
      }
      .video-test-label {
				position: absolute;
				top: 0;
				right: 0;
				background: var(--clr-white);
				border: 1px solid var(--clr-black);
				padding: 5px;
				color: var(--clr-test-flag);
				font-weight: bold;
			}
    }
  }
`;

export default FeaturedItemHolder;